export var TABLE_ROW_HEIGHT = 40;
export var COMM_LIST_TABLE_KEYS = {
  ROLE: 'role',
  NAME: 'userId',
  PLAN: 'plan',
  PERCENTAGE: 'percentage',
  VOLUME_BASED_PERCENTAGE: 'volumeBasedPercentage',
  BASE_COMMISSION_AMOUNT: 'amount',
  SPIFF_AMOUNT: 'spiffAmount',
  TOTAL_COMMISSION_AMOUNT: 'totalCommissionAmount',
  ACTIONS: 'actions'
};
export var TABLE_PROPS = {
  showPagination: false,
  minRows: 4,
  rowHeight: 40
};